// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","greyBg":"App_greyBg__y4typ","beigeBg":"App_beigeBg__eO8+b"};